<div class="lokos-radio">
    <mat-radio-group
        [formControl]="control"
        [labelPosition]="labelPosition"
        [required]="required"
    >
        <mat-radio-button
            [value]="value"
            [checked]="selected"
            (change)="onChange.emit($event)"
        >
            @if (label) {
                <mat-label>
                    {{ label | translate }}
                    <span class="required">{{ required ? '*' : '' }}</span>
                </mat-label>
            }
        </mat-radio-button>
    </mat-radio-group>
    @if (control.invalid && (control.dirty || control.touched)) {
        <mat-error>{{ getErrorMessage() | translate }}</mat-error>
    }
</div>
